/*************************
 * @license
 * Copyright 2024 Myenergi Ltd. All rights reserved.
 * No part of this work may be reproduced, stored in a retrieval system of any nature, or transmitted, in any form or by any means without the prior written permission of Myenergi Ltd., the copyright owner.
 * If any unauthorised acts are carried out in relation to this copyright work, a civil claim for damages may be made and/or a criminal prosecution may result.
 *************************/
import { DeviceName, Permission } from "models/graphql";

export interface DeviceStatusPanelSubMenu {
  i18n: string;
  requiredPermission: Permission;
  type: DeviceStatusSubMenuType;
  deviceTypes: Set<DeviceName>;
}

export type DeviceStatusSubMenuType =
  | "status"
  | "history"
  | "dsr"
  | "errors-warnings"
  | "ocpp"
  | "g100-events"
  | "integrations"
  | "rig-data"
  | "commissioning";

const deviceStatusPanelSubMenus: DeviceStatusPanelSubMenu[] = [
  {
    type: "status",
    i18n: "hubDetailsPage.deviceStatusPanelDetails.subMenu.status",
    requiredPermission: Permission.hubDetailsView,
    deviceTypes: new Set([
      DeviceName.zappi1,
      DeviceName.zappi2,
      DeviceName.rapidZappi,
      DeviceName.eddi,
      DeviceName.eddiPlus,
      DeviceName.harvi,
      DeviceName.libbi,
    ]),
  },
  {
    type: "history",
    i18n: "hubDetailsPage.deviceStatusPanelDetails.subMenu.history",
    requiredPermission: Permission.hubDetailsView,
    deviceTypes: new Set([
      DeviceName.zappi1,
      DeviceName.zappi2,
      DeviceName.rapidZappi,
      DeviceName.eddi,
      DeviceName.eddiPlus,
      DeviceName.libbi,
      DeviceName.harvi,
    ]),
  },
  {
    type: "g100-events",
    i18n: "hubDetailsPage.deviceStatusPanelDetails.subMenu.g100Events",
    requiredPermission: Permission.hubDetailsView,
    deviceTypes: new Set([
      DeviceName.zappi1,
      DeviceName.zappi2,
      DeviceName.rapidZappi,
      DeviceName.eddi,
      DeviceName.eddiPlus,
      DeviceName.libbi,
    ]),
  },
  {
    type: "dsr",
    i18n: "hubDetailsPage.deviceStatusPanelDetails.subMenu.dsr",
    requiredPermission: Permission.aggregatorView,
    deviceTypes: new Set([
      DeviceName.zappi1,
      DeviceName.zappi2,
      DeviceName.rapidZappi,
      DeviceName.eddi,
      DeviceName.eddiPlus,
    ]),
  },
  {
    type: "ocpp",
    i18n: "hubDetailsPage.ocppTab",
    requiredPermission: Permission.hubDetailsView,
    deviceTypes: new Set([DeviceName.zappi2, DeviceName.rapidZappi]),
  },
  {
    type: "errors-warnings",
    i18n: "hubDetailsPage.deviceStatusPanelDetails.subMenu.errorsAndWarnings",
    requiredPermission: Permission.hubDetailsView,
    deviceTypes: new Set([DeviceName.libbi]),
  },
  {
    type: "integrations",
    i18n: "hubDetailsPage.integrations",
    requiredPermission: Permission.hubDetailsView,
    deviceTypes: new Set([
      DeviceName.zappi1,
      DeviceName.zappi2,
      DeviceName.rapidZappi,
      DeviceName.eddi,
      DeviceName.eddiPlus,
      DeviceName.libbi,
    ]),
  },
  {
    type: "rig-data",
    i18n: "hubDetailsPage.deviceStatusPanelDetails.subMenu.rigData",
    requiredPermission: Permission.hubDetailsView,
    deviceTypes: new Set([
      DeviceName.zappi1,
      DeviceName.zappi2,
      DeviceName.rapidZappi,
      DeviceName.eddi,
      DeviceName.eddiPlus,
      DeviceName.libbi,
      DeviceName.harvi,
    ]),
  },
  {
    type: "commissioning",
    i18n: "hubDetailsPage.deviceStatusPanelDetails.subMenu.commissioning",
    requiredPermission: Permission.hubDetailsView,
    deviceTypes: new Set([DeviceName.rapidZappi]),
  },
];

export default deviceStatusPanelSubMenus;
